module.exports = __webpack_public_path__ + "static/arms_of_hadar-6d6b9d04c1babf6d49960b34b568785a.jpg";